import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { groupLabels } from "./emailGroups"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { USER_EMAIL_SETTINGS } from "../../config/featureFlagKeys"
import { getOfficeEmailMute } from "../../features/emailSettings/emailSettings"

const joinWithAnd = (items) => {
  if (items.length < 2) return items.join("")
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`
}

const nameOf = (login) => [login?.firstName, login?.lastName].filter(Boolean).join(" ")

const quoted = (label) => `“${label}”`

const normalizeAddress = (address) => String(address || "").trim().toLowerCase()

const OfficeEmailMuteHint = ({ groupId, address }) => {
  const dispatch = useDispatch()
  const flagOn = useSelector(selectFeatureFlag(USER_EMAIL_SETTINGS))
  const [answer, setAnswer] = useState(null)

  useEffect(() => {
    setAnswer(null)
    if (!flagOn || !groupId) return undefined
    let active = true
    dispatch(getOfficeEmailMute(groupId)).then((result) => {
      if (!active || result.error) return
      setAnswer(result.payload || null)
    })
    return () => {
      active = false
    }
  }, [flagOn, groupId, dispatch])

  const typed = normalizeAddress(address)
  if (!flagOn || !groupId || !answer || !typed || normalizeAddress(answer.address) !== typed) return null

  const names = (answer.logins || []).map(nameOf).filter(Boolean)
  const skipsAll = answer.skipsAll === true
  const labels = groupLabels(answer.skippedGroups)
  if (names.length === 0 || (!skipsAll && labels.length === 0)) return null

  const text = skipsAll
    ? `This address belongs to ${joinWithAnd(names)}, who muted all notification emails. Office emails are not sent to it.`
    : `This address belongs to ${joinWithAnd(names)}, who muted ${joinWithAnd(labels.map(quoted))}. Office emails about those are not sent to it.`

  return (
    <div className="mt-1">
      <span className="text-sm select-none text-text-secondary">{text}</span>
    </div>
  )
}

OfficeEmailMuteHint.propTypes = {
  groupId: PropTypes.string,
  address: PropTypes.string,
}

export default OfficeEmailMuteHint
